import "./App.css";
import "react-toastify/dist/ReactToastify.css";

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import About from "./screens/About/About";
import FAQ from "./screens/FAQ/FAQ";
import Fine from "./screens/Fine/Fine";
import ForgotPassword from "./components/modals/ForgotPassword/ForgotPassword";
import IDMatch from "./components/modals/IDMatch/IDMatch";
import Landing from "./screens/Landing/Landing";
import LeavePage from "./components/modals/LeavePage/LeavePage";
import Login from "./components/modals/Login/Login";
import NotPayable from "./components/modals/NotPayable/NotPayable";
import PaymentStatus from "./components/modals/PaymentStatus/PaymentStatus";
import Profile from "./screens/Profile/Profile";
import Register from "./screens/Register/Register";
import RegisterForWarrant from "./screens/RegisterForWarrant/RegisterForWarrant";
import ResetPassword from "./screens/ResetPassword/ResetPassword";
import { ToastContainer } from "react-toastify";
import VerifyEmail from "./screens/VerifyEmail/VerifyEmail";
import { useAppSelector } from "./hooks/reduxHooks";
import MaintenanceHeader from "./components/MaintenanceHeader/MaintenanceHeader";

function App() {
  const modalState = useAppSelector((state) => state.modal);
  const {
    notPayableVisible,
    loginVisible,
    leavePageVisible,
    forgotPasswordVisible,
    idMatchVisible,
  } = modalState;

  return (
    <>
      <MaintenanceHeader />
      <ToastContainer />
      <div className="App" id="App">
        <BrowserRouter>
          {/* Modals */}
          {notPayableVisible && <NotPayable />}
          {loginVisible && <Login />}
          {leavePageVisible && <LeavePage />}
          {forgotPasswordVisible && <ForgotPassword />}
          {idMatchVisible && <IDMatch />}
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/warrant" element={<RegisterForWarrant />} />
            <Route path="/fine" element={<Fine />} />
            <Route path="/register" element={<Register />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/verify" element={<VerifyEmail />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/payment" element={<PaymentStatus />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/about" element={<About />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;
